import { defaultApiBasicX } from '@wiggot/apis'
import type { IResponseService } from '@wiggot/interfaces'

interface IPropertySeenInteractionProps {
  link: string
  propertyLegacyIds: string[]
  userId: string
  type: string
}

interface IPropertySeenInteraction {
  propertyLegacyIds: string[]
  interactionType: string
  data?: IPropertySeenInteractionProps
  metadata: {
    link: string
  }
  source: string
  userId: string
}

export const propertyInteraction = async ({
  propertyLegacyIds,
  link,
  userId,
  type
}: IPropertySeenInteractionProps): Promise<
  IResponseService<IPropertySeenInteractionProps>
> => {
  try {
    const response = await defaultApiBasicX.post<
      IPropertySeenInteraction,
      IPropertySeenInteraction
    >(`lead-management/interaction/property`, {
      propertyLegacyIds,
      interactionType: type,
      metadata: {
        link
      },
      source: 'WIGGOT_PUBLIC_DATA_SHEET',
      userId: userId?.toString() || ''
    })

    return {
      isSuccess: true,
      data: response?.data
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}
